import LastNotAuthorizedMessage from 'components/Pages/Admin/CheckinPage/QrCodeScanner/ScanContent/Alert/LastNotAuthorizedMessage';
import NotAuthorizedMessage from 'components/Pages/Admin/CheckinPage/QrCodeScanner/ScanContent/Alert/NotAuthorizedMessage';
import { Html5QrcodeScannerState } from 'html5-qrcode';

import { Attendance } from '../types';
import LastCheckinMessage from './Alert/LastCheckinMessage';
import LoadingMessage from './Alert/LoadingMessage';
import SuccessMessage from './Alert/SuccessMessage';
import EmptyState from './EmptyState';
import LoadingState from './LoadingState';
import RequestPermission from './RequestPermission';
import ScanResult from './ScanResult';
import StartScanner from './StartScanner';

type ScanContentProps = {
  showSuccessMessage: boolean;
  showLastCheckinMessage: boolean;
  showLoadingMessage: boolean;
  showNotAuthorizedMessage: boolean;
  showLastNotAuthorizedMessage: boolean;
  cameraId: string | null;
  scannerState: Html5QrcodeScannerState | null;
  attendance: Attendance | null;
  requestPermission: () => void;
  startScanner: () => void;
  errorMessage: string | null;
  staffToken: string;
  clearScanContent: () => void;
};

const ScanContent = ({
  showLastCheckinMessage,
  showSuccessMessage,
  showLoadingMessage,
  showNotAuthorizedMessage,
  showLastNotAuthorizedMessage,
  cameraId,
  scannerState,
  attendance,
  requestPermission,
  startScanner,
  errorMessage,
  staffToken,
  clearScanContent
}: ScanContentProps) => {
  return (
    <>
      <SuccessMessage open={showSuccessMessage} />
      <LastCheckinMessage open={showLastCheckinMessage} />
      <LoadingMessage open={showLoadingMessage} />
      <NotAuthorizedMessage open={showNotAuthorizedMessage} />
      <LastNotAuthorizedMessage open={showLastNotAuthorizedMessage} />

      <RequestPermission cameraId={cameraId} requestPermission={requestPermission} />
      <StartScanner cameraId={cameraId} startScanner={startScanner} scannerState={scannerState} />

      <EmptyState
        scannerState={scannerState}
        attendance={attendance}
        loading={showLoadingMessage}
        errorMessage={errorMessage}
      />
      <LoadingState showLoadingMessage={showLoadingMessage} />

      <ScanResult
        attendance={attendance}
        errorMessage={errorMessage}
        loading={showLoadingMessage}
        staffToken={staffToken}
        clearScanContent={clearScanContent}
      />
    </>
  );
};

export default ScanContent;
